<template lang="pug">
v-dialog(:model-value='visible' width='1700px' @click:outside='cancel')
    v-card(v-if='visible')
        v-card-text
            .ma-6
                v-row
                    v-col
                        MilSymbolTextPromptDropdown(
                            @mil-symbol-dto-selected='copyMilSymbolToMenus'
                        )

                v-row
                    v-col
                        v-row.mb-4
                            mil-symbol(:milSymbol='milSymbol' :size='200' outlineColor='#1f1f1f')

                        v-autocomplete(
                            v-if='setListOfIcons.length > 0'
                            label='Model after an existing icon'
                            :items='setListOfIcons'
                            v-model='copiedIconCode'
                            item-title='forceName'
                            item-value='iconCode'
                            :filter='filterName'
                            hide-details
                            clearable
                            chips
                        )
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(:value='item.raw.iconCode')
                        v-autocomplete(
                            clearable
                            label='Country'
                            v-model='country'
                            :items='countryValues'
                            item-title='countryName'
                            :item-value='returnCountryCode'
                            auto-select-first
                            :filter='filterCountry'
                            hide-details
                        )

                        v-autocomplete(
                            label='Standard identity 1'
                            :items='standardIdentity1Values'
                            v-model='standardIdentity1'
                            item-title='name'
                            item-value='code'
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                        v-autocomplete(
                            label='Standard identity 2'
                            :items='standardIdentity2Values'
                            v-model='standardIdentity2'
                            item-title='name'
                            item-value='code'
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                        v-autocomplete(
                            label='Status'
                            :items='statusValues'
                            v-model='status'
                            item-title='name'
                            item-value='code'
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                    v-col
                        ValidatedTextField(
                            v-if='!hideUniqueDesignation'
                            placeholder='Unique Designation'
                            v-model='uniqueDesignation'
                            :rules='[rules.ruleGetterMaxLength(30)]'
                        )
                        v-autocomplete(
                            label='Symbol Set'
                            :items='symbolSetValues'
                            v-model='symbolSet'
                            item-title='name'
                            return-object
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewSymbolSet(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )

                        v-autocomplete(
                            v-if='!hideHeadquarters'
                            label='Headquarters/Task force/Dummy'
                            :items='headquartersTaskforceDummyValues'
                            v-model='headquartersTaskforceDummy'
                            item-title='name'
                            item-value='code'
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewHeadquartersTaskforceDummy(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )

                        v-autocomplete(
                            v-if='hasEchelon'
                            label='Echelon'
                            :items='echelonValues'
                            v-model='echelon'
                            item-title='name'
                            item-value='code'
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewEchelonMobilityTowedArray(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )

                        v-autocomplete(
                            v-if='hasMobility'
                            label='Mobility'
                            :items='mobilityValues'
                            v-model='mobility'
                            item-title='name'
                            item-value='code'
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewEchelonMobilityTowedArray(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )

                        v-autocomplete(
                            v-if='hasTowedArray'
                            label='Towed array'
                            :items='towedArrayValues'
                            v-model='towedArray'
                            item-title='name'
                            item-value='code'
                            auto-select-first
                            :filter='filterName'
                            hide-details
                        )
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewEchelonMobilityTowedArray(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )

                        v-autocomplete(
                            label='Icon'
                            :items='iconValues'
                            v-model='icon'
                            item-title='code'
                            item-value='code'
                            auto-select-first
                            :filter='filterIcon'
                            hide-details
                        )
                            template(v-slot:selection='{ item }')
                                span {{ item.raw.entity }}

                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewIcon(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )
                                    template(v-slot:title='{ title }')
                                        v-list-item-title(v-if='item.raw.entitySubtype')
                                            span.text-caption.text-grey.mr-1 {{ item.raw.entity }} - {{ item.raw.entityType }}
                                            span {{ item.raw.entitySubtype }}
                                        v-list-item-title(v-else-if='item.raw.entityType')
                                            span.text-caption.text-grey.mr-1 {{ item.raw.entity }} -
                                            span {{ item.raw.entityType }}
                                        v-list-item-title(v-else) {{ item.raw.entity }}

                        v-autocomplete(
                            v-if='hasModifier1'
                            label='Icon modifier 1'
                            :items='modifier1Values'
                            v-model='modifier1'
                            item-title='code'
                            item-value='code'
                            auto-select-first
                            :filter='filterModifier'
                            hide-details
                        )
                            template(v-slot:selection='{ item }')
                                span {{ item.raw.modifier }}
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewModifier1(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )
                                    template(v-slot:title='{ title }')
                                        v-list-item-title {{ item.raw.modifier }}

                        v-autocomplete(
                            v-if='hasModifier2'
                            label='Icon modifier 2'
                            :items='modifier2Values'
                            v-model='modifier2'
                            item-title='code'
                            item-value='code'
                            auto-select-first
                            :filter='filterModifier'
                            hide-details
                        )
                            template(v-slot:selection='{ item }')
                                span {{ item.raw.modifier }}
                            template(v-slot:item='{ props, item }')
                                v-list-item(v-bind='props')
                                    template(v-slot:prepend)
                                        MilSymbol(
                                            :milSymbol='previewModifier2(item.raw.code)'
                                            :size='38'
                                            outlineColor='#1f1f1f'
                                        )
                                    template(v-slot:title='{ title }')
                                        v-list-item-title {{ item.raw.modifier }}
                        ValidatedTextField(
                            v-if='!hideHeadquarters'
                            label='Special headquarters'
                            v-model='specialHeadquarters'
                            :rules='[rules.ruleGetterMaxLength(9)]'
                            clearable
                            hideDetails
                        )
                        v-autocomplete(
                            label='Reinforced / Reduced'
                            v-model='reinforcedReduced'
                            :items='reinforcedReducedValues'
                            auto-select-first
                            :filter='filterReinforcedReduced'
                            hide-details
                        ) 

        v-divider
        v-card-actions
            v-spacer 
            ButtonExit(@click='cancel') Cancel
            ButtonSubmit(@click='save')
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import {
    standardIdentity1Values,
    standardIdentity2Values,
    symbolSetValues,
    statusValues,
    headquartersTaskforceDummyValues,
    SymbolSet,
    Icon,
    IconModifier,
    Echelon,
    TowedArray,
    Mobility,
    landunitSymbolSet,
    reinforcedReducedValues,
    ReinforcedReduced,
} from '../../util/MilSymbolConstants';
import ValidatedTextField from '@/common/Validation/ValidatedTextField.vue';
import MilSymbolDTO from '@/models/MilSymbol';
import MilSymbol from '@/common/MilSymbol/MilSymbol.vue';
import { ForceProfileDTOWithAliases } from '@/models/ForceProfileDTO';
import ButtonExit from '@/common/button-components/ButtonExit.vue';
import ButtonSubmit from '@/common/button-components/ButtonSubmit.vue';
import MilSymbolTextPromptDropdown from '@/common/MilSymbol/MilSymbolTextPromptDropdown.vue';
import { rules } from '@/common/';
import { countries, CountryDTO } from '@/common/MilSymbol/countries';

export default defineComponent({
    name: 'MilSymbolDialog',
    components: {
        ButtonSubmit,
        ButtonExit,
        MilSymbol,
        ValidatedTextField,
        MilSymbolTextPromptDropdown,
    },
    emits: ['saved', 'canceled'],
    props: {
        value: {
            type: Object as PropType<ForceProfileDTOWithAliases>,
            default: undefined,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        hideUniqueDesignation: {
            type: Boolean,
            default: false,
        },
        hideHeadquarters: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideReinforcedReduced: {
            type: Boolean,
            default: false,
        },
        setListOfIcons: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            countries,
            rules,
            version: '10',
            standardIdentity1: '0',
            standardIdentity2: '3',
            status: '0',
            echelon: '00',
            mobility: '00',
            towedArray: '00',
            icon: '000000',
            modifier1: '00',
            modifier2: '00',
            headquartersTaskforceDummy: '0',
            symbolSet: landunitSymbolSet as SymbolSet,
            standardIdentity1Values: standardIdentity1Values,
            standardIdentity2Values: standardIdentity2Values,
            statusValues: statusValues,
            headquartersTaskforceDummyValues: headquartersTaskforceDummyValues,
            symbolSetValues: symbolSetValues,
            reinforcedReducedValues: reinforcedReducedValues,
            specialHeadquarters: '',
            reinforcedReduced: undefined as ReinforcedReduced,
            uniqueDesignation: '',
            copiedIcon: undefined as Icon | undefined,
            copiedIconCode: null,
            country: '',
        };
    },
    computed: {
        orgChartElement: function (): Partial<ForceProfileDTOWithAliases> {
            if (!this.value) {
                return undefined;
            } else if (this.value.children) {
                return {
                    identifier: this.value.identifier,
                    code: this.milSymbol.code,
                    warfightingSymbol: this.milSymbol,
                };
            } else {
                return {
                    identifier: this.value.identifier,
                    code: this.milSymbol.code,
                    warfightingSymbol: this.milSymbol,
                };
            }
        },

        milSymbol: function (): MilSymbolDTO {
            const ret = {
                code: this.copiedIconCode ? this.copiedIconCode : this.code,
                specialHeadquarters: this.normalize(this.specialHeadquarters),
                reinforcedReduced: this.normalizedReinforcedReduced,
                uniqueDesignation: this.uniqueDesignation,
                country: this.country,
            };
            return ret;
        },
        code: function (): string {
            return (
                this.version +
                this.standardIdentity1 +
                this.standardIdentity2 +
                this.symbolSet.code + // e.g. 4th-5th index  2 characters for symbol set code
                this.status +
                this.headquartersTaskforceDummy + //e.g. 7th index 1 character
                this.echelonMobilityTowedArray +
                this.icon +
                (this.hasModifier1 ? this.modifier1 : '00') +
                (this.hasModifier2 ? this.modifier2 : '00')
            );
        },
        normalizedReinforcedReduced: function (): '+' | '-' | '±' {
            return this.reinforcedReducedValues.find((x) =>
                x.tags.some((t) => t == this.reinforcedReduced),
            )?.value;
        },
        iconValues: function (): readonly Icon[] {
            return this.symbolSet.icons;
        },
        hasModifier1: function (): boolean {
            return this.symbolSet.modifier1Values != undefined;
        },
        hasModifier2: function (): boolean {
            return this.symbolSet.modifier1Values != undefined;
        },
        modifier1Values: function (): readonly IconModifier[] {
            return this.symbolSet.modifier1Values ?? [];
        },
        modifier2Values: function (): readonly IconModifier[] {
            return this.symbolSet.modifier2Values ?? [];
        },
        echelonValues: function (): readonly Echelon[] {
            return this.symbolSet.echelonValues ?? [];
        },
        mobilityValues: function (): readonly Mobility[] {
            return this.symbolSet.mobilityValues ?? [];
        },
        towedArrayValues: function (): readonly TowedArray[] {
            return this.symbolSet.towedArrayValues ?? [];
        },
        hasEchelon: function (): boolean {
            return this.symbolSet?.echelonValues != undefined;
        },
        hasMobility: function (): boolean {
            return this.symbolSet?.mobilityValues != undefined;
        },
        hasTowedArray: function (): boolean {
            return this.symbolSet?.towedArrayValues != undefined;
        },
        echelonMobilityTowedArray: function (): string {
            if (this.hasEchelon) return this.echelon;
            if (this.hasMobility) return this.mobility;
            if (this.hasTowedArray) return this.towedArray;
            return '00';
        },
        countryValues: function (): CountryDTO[] {
            return this.countries;
        },
    },
    watch: {
        value: {
            handler: function (newValue: ForceProfileDTOWithAliases) {
                this.setData(newValue);
            },
            deep: true,
        },

        copiedIconCode: {
            handler: function (newValue: string) {
                if (newValue) {
                    this.setCodeInformation(newValue);
                    this.clearCopiedIconCode();
                }
            },
            deep: true,
        },
    },
    created() {
        this.setData(this.value);
        this.clearCopiedIconCode();
    },
    mounted() {
        this.clearCopiedIconCode();
    },
    methods: {
        returnCountryCode(countryData: CountryDTO): string {
            const fields = [
                countryData.alpha2,
                countryData.alpha3,
                countryData.flagCode,
                countryData.countryName,
            ];
            return fields.find((field) => field && field.trim());
        },
        clearCopiedIconCode() {
            this.copiedIconCode = null;
        },
        normalize(input: string | undefined): string | undefined {
            if (!input) return undefined;
            const trimmed = input.trim();
            return trimmed == '' ? undefined : trimmed;
        },
        filterIcon(item: Icon, queryText: string, _: string) {
            const searchTerms = queryText.toLowerCase().split(' ');
            const tags = `${item.entity} ${item.entityType ?? ''} ${item.entitySubtype ?? ''}`
                .toLowerCase()
                .split(' ');
            return searchTerms.every((s) => tags.some((t) => t.startsWith(s)));
        },
        filterName(item: { name: string }, queryText: string, _: string) {
            const searchTerms = queryText.toLowerCase().split(' ');
            const tags = item.name.toLowerCase().split(' ');
            return searchTerms.every((s) => tags.some((t) => t.startsWith(s)));
        },
        filterModifier(item: IconModifier, queryText: string, _: string) {
            const searchTerms = queryText.toLowerCase().split(' ');
            const tags = item.modifier.toLowerCase().split(' ');
            return searchTerms.every((s) => tags.some((t) => t.startsWith(s)));
        },
        filterReinforcedReduced(item: { tags: string[] }, queryText: string, _: string) {
            return item.tags.some((t) => t.startsWith(queryText));
        },
        filterCountry(item: string, queryText: string) {
            return item.toLowerCase().startsWith(queryText.toLowerCase());
        },
        previewIcon(icon: string): MilSymbolDTO {
            return {
                code: this.code.slice(0, 10) + icon + this.code.slice(16),
            };
        },
        previewSymbolSet(code: SymbolSet): MilSymbolDTO {
            return {
                code: this.code.slice(0, 4) + code + this.code.slice(6),
            };
        },
        previewHeadquartersTaskforceDummy(code: string): MilSymbolDTO {
            return {
                code: this.code.slice(0, 7) + code + this.code.slice(8),
            };
        },
        previewEchelonMobilityTowedArray(code: string): MilSymbolDTO {
            return {
                code: this.code.slice(0, 8) + code + this.code.slice(10),
            };
        },
        previewModifier1(modifier: string): MilSymbolDTO {
            return {
                code: this.code.slice(0, 16) + modifier + this.code.slice(18),
            };
        },
        previewModifier2(modifier: string): MilSymbolDTO {
            return {
                code: this.code.slice(0, 18) + modifier,
            };
        },
        copyMilSymbolToMenus(milSymbol: MilSymbolDTO) {
            this.specialHeadquarters = milSymbol.specialHeadquarters ?? '';
            if (milSymbol.country || milSymbol.reinforcedReduced || milSymbol.uniqueDesignation) {
                throw Error(
                    'Have not implemented copying of country, reinforcedReduced or uniqueDesignation',
                );
            }
            this.setCodeInformation(milSymbol.code);
        },
        setData(m: ForceProfileDTOWithAliases) {
            if (!m || !m.warfightingSymbol) {
                return;
            }

            this.uniqueDesignation = m.name;
            this.country = m.warfightingSymbol.country ?? '';
            this.specialHeadquarters = m.warfightingSymbol.specialHeadquarters ?? '';
            this.reinforcedReduced = m.warfightingSymbol.reinforcedReduced ?? '';
            const code = m.warfightingSymbol.code;
            this.setCodeInformation(code);
        },
        setCodeInformation(code: string): void {
            this.version = code.slice(0, 2);
            this.standardIdentity1 = code.slice(2, 3);
            this.standardIdentity2 = code.slice(3, 4);
            const symbolSetCode = code.slice(4, 6);

            this.symbolSet = symbolSetValues.find((x) => x.code == symbolSetCode) as SymbolSet;

            this.status = code.slice(6, 7);
            this.headquartersTaskforceDummy = code.slice(7, 8);
            const echelonMobilityTowedArrayCode = code.slice(8, 10);

            if (this.hasEchelon) this.echelon = echelonMobilityTowedArrayCode;
            if (this.hasMobility) this.mobility = echelonMobilityTowedArrayCode;
            if (this.hasTowedArray) this.towedArray = echelonMobilityTowedArrayCode;

            this.icon = code.slice(10, 16);
            this.modifier1 = code.slice(16, 18);
            this.modifier2 = code.slice(18, 20);
        },
        save: function () {
            this.$emit('saved', this.orgChartElement);
            this.clearCopiedIconCode();
        },
        cancel: function () {
            this.$emit('canceled');
            this.clearCopiedIconCode();
        },
    },
});
</script>
